import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

import { onMounted, computed, ref } from 'vue';
import { data } from '../composables/useData';
import { method } from '../composables/useMethod';
import DayCounts from './ReportComponents/DayCounts.vue';
import DeviceCounts from './ReportComponents/DeviceCounts.vue';
import SearchEngineCounts from './ReportComponents/SearchEngineCounts.vue';
import PageData from './ReportComponents/PageData.vue';
import RegionData from './ReportComponents/RegionData.vue';
import SourceData from './ReportComponents/SourceData.vue';
import TopView from './ReportComponents/TopView.vue';
import { DefineComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Ga4ReportPage',
  setup(__props) {

const componentsMap: { [key: string]: DefineComponent<object, object, any> } = {
  TopView,
  DayCounts,
  DeviceCounts,
  SearchEngineCounts,
  PageData,
  RegionData,
  SourceData,
};

const getComponent = (componentName: string): DefineComponent<object, object, any> | null => {
  const component = componentsMap[componentName];
  return componentsMap[componentName] || null;
};


return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_tabs, {
      modelValue: _unref(data).loginUser.activeComponentIndex,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).loginUser.activeComponentIndex) = $event)),
      "align-tabs": "center",
      color: "info",
      "show-arrows": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).loginUser.reportList, (reportSheet, i) => {
          return (_openBlock(), _createBlock(_component_v_tab, { key: i }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(reportSheet.title), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_tabs_window, {
      modelValue: _unref(data).loginUser.activeComponentIndex,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).loginUser.activeComponentIndex) = $event)),
      style: {"height":"700px"},
      "show-arrows": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).loginUser.reportList, (reportSheet, i) => {
          return (_openBlock(), _createBlock(_component_v_tabs_window_item, { key: i }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(reportSheet.componentName))))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})